import DOMPurify from "dompurify";

/**
 * Sanitizes article HTML (scraped from third-party sources) before it is
 * injected with dangerouslySetInnerHTML. Blocks scripts, event handlers,
 * iframes from unknown origins and javascript: URLs.
 */
export const sanitizeArticleHtml = (html: string): string => {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p", "br", "hr", "div", "span", "section", "article",
      "h1", "h2", "h3", "h4", "h5", "h6",
      "strong", "b", "em", "i", "u", "s", "sub", "sup", "mark", "small",
      "ul", "ol", "li", "dl", "dt", "dd",
      "blockquote", "q", "cite", "pre", "code",
      "a", "img", "figure", "figcaption", "picture", "source",
      "table", "thead", "tbody", "tfoot", "tr", "th", "td", "caption", "col", "colgroup",
      "time", "abbr",
    ],
    ALLOWED_ATTR: [
      "href", "title", "target", "rel", "src", "srcset", "sizes", "alt",
      "width", "height", "loading", "class", "id", "dir", "lang",
      "colspan", "rowspan", "datetime", "data-tweet-id", "data-tweet-url",
    ],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|#|\/)/i,
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input", "button", "link", "meta"],
    FORBID_ATTR: ["style", "onerror", "onload", "onclick", "onmouseover", "formaction", "srcdoc"],
    ALLOW_DATA_ATTR: true,
  });
};

export default sanitizeArticleHtml;
